export default __webpack_public_path__ + "static/media/coracao-olhos@3x.76853a5c.png";